(function () {
  const faqList = document.getElementById("faq-list");
  if (!faqList) return;

  const items = faqList.querySelectorAll("[data-faq-item]");

  items.forEach((item) => {
    const btn = item.querySelector(".faq-question");
    if (!btn) return;

    btn.addEventListener("click", () => {
      const isOpen = item.classList.contains("faq-item--open");

      items.forEach((other) => {
        other.classList.remove("faq-item--open");
        const otherBtn = other.querySelector(".faq-question");
        otherBtn?.setAttribute("aria-expanded", "false");
      });

      if (!isOpen) {
        item.classList.add("faq-item--open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });
})();
